import { render, staticRenderFns } from "./Template58.vue?vue&type=template&id=c606dfc6&scoped=true&"
import script from "./Template58.vue?vue&type=script&lang=js&"
export * from "./Template58.vue?vue&type=script&lang=js&"
import style0 from "./Template58.vue?vue&type=style&index=0&id=c606dfc6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c606dfc6",
  null
  
)

export default component.exports